var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgShareButton = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3.95325 6.99815L1.61261 9.33914C0.535379 10.4165 0.535379 12.1634 1.61261 13.2408C2.68988 14.3182 4.43642 14.3182 5.51366 13.2408L7.85429 10.8998",
  stroke: "#727273",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.9479 7.7998L13.2886 5.45882C14.3658 4.38142 14.3658 2.63459 13.2886 1.55719C12.2113 0.47977 10.4647 0.47977 9.38751 1.55719L7.04688 3.89818",
  stroke: "#727273",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.69531 10.1602L10.2122 4.64241",
  stroke: "#727273",
  strokeWidth: 1.4,
  strokeLinecap: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgShareButton);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuOTUzMjUgNi45OTgxNUwxLjYxMjYxIDkuMzM5MTRDMC41MzUzNzkgMTAuNDE2NSAwLjUzNTM3OSAxMi4xNjM0IDEuNjEyNjEgMTMuMjQwOEMyLjY4OTg4IDE0LjMxODIgNC40MzY0MiAxNC4zMTgyIDUuNTEzNjYgMTMuMjQwOEw3Ljg1NDI5IDEwLjg5OTgiIHN0cm9rZT0iIzcyNzI3MyIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTAuOTQ3OSA3Ljc5OThMMTMuMjg4NiA1LjQ1ODgyQzE0LjM2NTggNC4zODE0MiAxNC4zNjU4IDIuNjM0NTkgMTMuMjg4NiAxLjU1NzE5QzEyLjIxMTMgMC40Nzk3NyAxMC40NjQ3IDAuNDc5NzcgOS4zODc1MSAxLjU1NzE5TDcuMDQ2ODggMy44OTgxOCIgc3Ryb2tlPSIjNzI3MjczIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjY5NTMxIDEwLjE2MDJMMTAuMjEyMiA0LjY0MjQxIiBzdHJva2U9IiM3MjcyNzMiIHN0cm9rZS13aWR0aD0iMS40IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";